module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAATJJREFUSEvt1CFInVEUwPHfKYLgwKZB0Ga0CBbnulo1iSIWg6BRcUHEsiDMMJMwQUSwCIMJNjFYREHT4kBxVQxTLG9c+N7jQ7/J53u85o33nvO/3P8594QmrWgS1zu4ZramolKpHGKwAeeXEfGxmp8Hj2MKw3XAT/A1Ig6KwA/4jB7MvQG+jVN8i4iWIvA9PmALF9gsAV9EJxbwGBGtr4HT2TE2sIO2ggueMIFJjGbnpcAp9hdW8AXdOfgfzGMZfbn90uDfGfguc9+PK6xmr1hC71vBZxkgFaYdM+jANb4jqUgakttPZVXs40fmN//lb9D1zPcsBjD9WvH+Yj1LTG1XdqUi32Ltf+2WPscIxsoSc3E/sRsRe0XtdoShOqDVlPOIqI2E97H5cmw24LYwtWmO/wHt3VwXzm9nugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/youxiang.png
// module id = rflu
// module chunks = 26